import { createIcon } from '@chakra-ui/icons'

export const ZoomMinusIcon = createIcon({
  displayName: 'ZoomMinusIcon',
  viewBox: '0 0 24 24',
  path: <rect x="5" y="11" width="14" height="2" rx="1" fill="#231B22" />,
})
